import React, { useContext, useEffect, useState } from "react";
import "./SlotGamesStyle.scss";
import { slotGamesTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import GameCard from "../Common_UI_Kit/GameCard";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";
import { getSlotGames } from "network/game.services";
import { convertToCamelCase } from "util";
import { GameContext } from "context/context";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";

const SlotGamesSection = ({ sectionHeadingText }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      slidesToScroll: "auto",
      align: "start",
      loop: true,
    },
    [
      AutoScroll({
        playOnInit: true,
        stopOnInteraction: false,
        speed: 1.5,
        startDelay: 0,
      }),
    ]
  );

  const { gameList } = useContext(GameContext);

  useEffect(() => {
    function handleCallback(data) {
      setSlotGames(data);
    }

    const params = {
      page: 1,
      perPage: 10,
    };
    getSlotGames(handleCallback, params);
  }, []);

  const [slotGames, setSlotGames] = useState([]);

  const { slotGamesContent } = slotGamesTextContent;

  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/slot-games-list");
  };

  const handleCardClick = (game) => {
    navigate(`/slot-game-info`, { state: game });
  };

  return (
    <section className="slot-games-section">
      <div className="slot-games-wrap">
        <SectionHeading>
          {sectionHeadingText || slotGamesTextContent.headingText}
        </SectionHeading>

        <div className="slot-games-box">
          <p className="para-text">{slotGamesTextContent.paraText}</p>

          {/* <div className="games-grid-box">
            {gameList?.map((game) => {
              const imgName = convertToCamelCase(game.name)
              console.log('imgName: ', imgName);
              const img = `/assets/images/slot/thumbnail/${imgName}.png`
              return <GameCard
                key={game?.id}
                gameNameText={game.name}
                gameImageSrc={img}
                onClick={() => handleCardClick(game)}
              />
            })}
          </div> */}

          <div className="embla">
            <div className="embla__viewport" ref={emblaRef}>
              <div className="embla__container">
                {gameList?.map((game) => {
                  const imgName = convertToCamelCase(game.name);
                  console.log("imgName: ", imgName);
                  const img = `/assets/images/slot/thumbnail/${imgName}.png`;
                  return (
                    <div className="embla__slide">
                      <GameCard
                        key={game?.id}
                        gameNameText={game.name}
                        gameImageSrc={img}
                        onClick={() => handleCardClick(game)}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="btn-box">
            <CustomButton
              buttonType="secondary"
              label={slotGamesTextContent.btnText}
              onClick={handleButtonClick}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlotGamesSection;
